import { Asset, AssetKind } from "@hydrologiq/gql/graphql"
import Service from "../generic/Service"
import { days } from "timezonecomplete"
import { nowDateTime, toUserTZ } from "@hydrologiq/common/helpers/date"
import { useGetFeature } from "@hydrologiq/shared/providers/helpers/useFeature"
const AssetNextService = ({ context }: { context?: Asset }) => {
  const servicingEnabled = useGetFeature("servicing")
  const date = nowDateTime().add(days(30))

  const hide = !context || [AssetKind.RemoteMonitoring, AssetKind.GasManagement].includes(context.kind)
  return hide || !servicingEnabled ? null : (
    <Service heading={"Planned service"} date={toUserTZ(date)} period={"Next"} />
  )
}

export default AssetNextService
